import axios from 'axios'

export default class Krpano {
  static getVirtualTourData(tour) {
    return axios.get(`/${tour}.json`).then(({ data }) => data)
  }
  static getVirtualTourSettings(tour) {
    return axios({ url: `/${tour}.json`, baseURL: '/settings' }).then(({ data }) => data)
  }

  static getPopupData(tour, popup) {
    return axios.get(`/popups/${tour}/${popup}`).then(({ data }) => data)
  }

  static getARModelLink(modelId) {
    return axios.get(`/virtual-tour/ar-model/${modelId}`).then(({ data }) => data)
  }
}
